import { ReactNode } from "react";
import { PropertyContext } from "./property-context";

export function InnerPropertiesProvider({
  children,
  properties,
}: {
  children: ReactNode;
  properties: string[];
}) {
  return (
    <PropertyContext.Provider value={properties}>
      {children}
    </PropertyContext.Provider>
  );
}
